import { TextField } from '@mui/material';
import { Box } from '@mui/system';

import { FC } from 'react';
import { ReactSetState } from '../../models';

export interface ITextCell {
  index: number;
  value: any;
  setValue: ReactSetState<any>;
  hasChanges: boolean;
  setHasChanges: ReactSetState<boolean>;
  setRows: ReactSetState<any>;
  original: any;
  propertyName: string;
  placeholder: string;
}
export const TextCell: FC<ITextCell> = ({
  index,
  value,
  setValue,
  hasChanges,
  setHasChanges,
  setRows,
  original,
  propertyName,
  placeholder,
}) => {
  return (
    <Box>
      {/* {console.log(index)} */}
      <TextField
        fullWidth
        inputProps={{
          id: `${propertyName}-${index}`,
        }}
        placeholder={placeholder}
        value={value}
        onChange={event => setValue(event.target.value)}
        onBlur={e => {
          // If user clicked away and changes have not been saved, enforce the viewport does not move.

          setRows((state: any) => {
            const accountIndex = state.indexOf(original);

            // Enable save button
            if (state[accountIndex][propertyName] !== value) {
              setHasChanges(true);
              // state[accountIndex].isEdited = true;
            }

            // Store changes in preparation for batch save
            state[accountIndex][propertyName] = value;
            return JSON.parse(JSON.stringify(state));
          });
        }}
      />
    </Box>
  );
};
